import { render } from "./ArticlesForm.vue?vue&type=template&id=14439ba9"
import script from "./ArticlesForm.vue?vue&type=script&lang=js"
export * from "./ArticlesForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__